import React from "react";
import { Box, FormGroup, FormControlLabel, Checkbox, Button, Typography } from "@mui/material";

const WEEKDAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export default function CustomWeekdaySelector({ selectedDays = [], onChange, onDone, dayColors = {} }) {
  const handleToggle = (day) => {
    if (selectedDays.includes(day)) {
      onChange(selectedDays.filter((d) => d !== day));
    } else {
      onChange([...selectedDays, day]);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="subtitle1" fontWeight={600} mb={1}>
        Days of the Week
      </Typography>
      <FormGroup row>
        {WEEKDAYS.map((day) => (
          <FormControlLabel
            key={day}
            control={
              <Checkbox
                checked={selectedDays.includes(day)}
                onChange={() => handleToggle(day)}
                color="primary"
              />
            }
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                {dayColors[day] && (
                  <Box sx={{ width: 10, height: 10, borderRadius: "50%", background: dayColors[day], flexShrink: 0 }} />
                )}
                {day}
              </Box>
            }
          />
        ))}
      </FormGroup>
      {onDone && (
        <Box mt={2}>
          <Button variant="contained" color="primary" onClick={onDone}>
            Done
          </Button>
        </Box>
      )}
    </Box>
  );
}
